/*
  HomePage.jsx
*/


import React, { Component } from 'react';  
import { Link } from 'react-router-dom';
import './HomePage.scss';

// components
import ComponentSectionOneHome from './../ComponentSectionOneHome';
import ComponentHeader from './../ComponentHeader';
import ComponentPop from './../ComponentPop';

// images

import Logo from '../../Media/svg/TWINFIN-LOGO.svg';

export default class HomePage extends React.Component {


    constructor(props) {
    super(props);

    // State.

    this.state = {
    
      active_one: false
   
    };
  }


  componentDidMount() {
    window.scrollTo(0, 0);
  

  }

    render(){


  return (
    <div className="home-page">
        <ComponentHeader/>
        <ComponentSectionOneHome />
    </div>
    );
  }
}